(function () {
  if (window.__SHFTDQuickAddInit) return;
  window.__SHFTDQuickAddInit = true;

  const CART_ADD_URL = (window.routes && window.routes.cart_add_url) || '/cart/add';
  const CART_URL = (window.routes && window.routes.cart_url) || '/cart';

  async function submit(form, options) {
    options = options || {};
    const submitButton = form.querySelector('[type="submit"]');
    if (!submitButton || submitButton.hasAttribute('disabled')) return;
    if (submitButton.getAttribute('aria-disabled') === 'true') return;

    const labelEl =
      options.labelSelector ? submitButton.querySelector(options.labelSelector) : submitButton;
    const originalLabel = labelEl ? labelEl.textContent : null;

    submitButton.setAttribute('aria-disabled', 'true');
    submitButton.classList.add('loading');
    if (labelEl && options.loadingLabel !== false) {
      labelEl.textContent = options.loadingLabel || 'Adding…';
    }

    const formData = new FormData(form);
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);

    try {
      const addRes = await fetch(CART_ADD_URL, {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest',
          Accept: 'application/javascript',
        },
        body: formData,
      });
      const addData = await addRes.json();

      if (addData.status) {
        console.error('[quick-add] error', addData);
        if (labelEl) {
          labelEl.textContent = addData.description || (window.shftdLocale && window.shftdLocale.try_again) || 'Try again';
          setTimeout(() => {
            if (originalLabel !== null) labelEl.textContent = originalLabel;
          }, 1800);
        }
        return;
      }

      const cartRes = await fetch(CART_URL + '.js', {
        headers: { Accept: 'application/json' },
      });
      const cart = await cartRes.json();

      const bubbleLink = document.getElementById('cart-icon-bubble');
      if (bubbleLink) {
        let bubbleCount = bubbleLink.querySelector('.header__cart-count');
        if (cart.item_count > 0) {
          if (!bubbleCount) {
            bubbleCount = document.createElement('span');
            bubbleCount.className = 'header__cart-count';
            bubbleLink.appendChild(bubbleCount);
          }
          bubbleCount.textContent = cart.item_count;
        } else if (bubbleCount) {
          bubbleCount.remove();
        }
      }

      const drawer = document.querySelector('cart-drawer');
      const drawerSection = addData.sections && addData.sections['cart-drawer'];
      const drawerInner = document.getElementById('CartDrawer');
      if (drawer && drawerSection) {
        const parsed = new DOMParser().parseFromString(drawerSection, 'text/html');
        const newInner = parsed.querySelector('#CartDrawer');
        if (drawerInner && newInner) {
          drawerInner.innerHTML = newInner.innerHTML;
        }
        if (cart.item_count > 0) drawer.classList.remove('is-empty');
        else drawer.classList.add('is-empty');
      }
      if (drawer) {
        // Opening must not depend on the sections payload: when it is missing
        // or the swap hiccups, the add still succeeded, and a drawer that
        // silently stays shut reads as a dead button. Stale contents (rare)
        // are corrected by the cart:item-added listeners.
        const overlay = drawer.querySelector('#CartDrawer-Overlay');
        if (overlay && typeof drawer.close === 'function') {
          overlay.addEventListener('click', drawer.close.bind(drawer), { once: true });
        }
        if (typeof drawer.open === 'function') drawer.open(submitButton);
      }

      document.dispatchEvent(
        new CustomEvent('cart:item-added', {
          detail: { source: options.source || 'quick-add', cart: cart },
        })
      );
    } catch (err) {
      console.error('[quick-add] failed', err);
    } finally {
      submitButton.classList.remove('loading');
      submitButton.removeAttribute('aria-disabled');
      if (labelEl && originalLabel !== null) labelEl.textContent = originalLabel;
    }
  }

  function bind(form, options) {
    if (!form || form.dataset.quickAddBound === '1') return;
    form.dataset.quickAddBound = '1';
    form.addEventListener('submit', (event) => {
      event.preventDefault();
      submit(form, options || {});
    });
  }

  /**
   * Add a single variant directly (no form, no drawer opening when silent).
   * Reuses the same sections-render flow so the drawer content + header
   * bubble stay correct; dispatches the same cart:item-added event.
   * Returns the cart JSON, or null on failure.
   */
  async function addVariant(variantId, options) {
    options = options || {};
    const formData = new FormData();
    formData.append('id', String(variantId));
    formData.append('quantity', String(options.quantity || 1));
    formData.append('sections', 'cart-drawer');
    formData.append('sections_url', window.location.pathname);
    try {
      const addRes = await fetch(CART_ADD_URL, {
        method: 'POST',
        headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
        body: formData,
      });
      const addData = await addRes.json();
      if (addData.status) {
        console.error('[quick-add] addVariant error', addData);
        return null;
      }
      const cartRes = await fetch(CART_URL + '.js', { headers: { Accept: 'application/json' } });
      const cart = await cartRes.json();

      const bubbleLink = document.getElementById('cart-icon-bubble');
      if (bubbleLink) {
        let bubbleCount = bubbleLink.querySelector('.header__cart-count');
        if (cart.item_count > 0) {
          if (!bubbleCount) {
            bubbleCount = document.createElement('span');
            bubbleCount.className = 'header__cart-count';
            bubbleLink.appendChild(bubbleCount);
          }
          bubbleCount.textContent = cart.item_count;
        } else if (bubbleCount) {
          bubbleCount.remove();
        }
      }

      const drawer = document.querySelector('cart-drawer');
      const drawerSection = addData.sections && addData.sections['cart-drawer'];
      const drawerInner = document.getElementById('CartDrawer');
      if (drawer && drawerSection) {
        const parsed = new DOMParser().parseFromString(drawerSection, 'text/html');
        const newInner = parsed.querySelector('#CartDrawer');
        if (drawerInner && newInner) drawerInner.innerHTML = newInner.innerHTML;
        if (cart.item_count > 0) drawer.classList.remove('is-empty');
        else drawer.classList.add('is-empty');
        if (!options.silent && typeof drawer.open === 'function') drawer.open();
      }

      document.dispatchEvent(
        new CustomEvent('cart:item-added', {
          detail: { source: options.source || 'quick-add', cart: cart },
        })
      );
      return cart;
    } catch (err) {
      console.error('[quick-add] addVariant failed', err);
      return null;
    }
  }

  window.SHFTDQuickAdd = { bind: bind, submit: submit, addVariant: addVariant };
})();
